import {
	Component,
	OnInit,
	AfterViewInit,
	ViewChild,
	ViewEncapsulation
} from "@angular/core";
//import { AuthHttp } from 'angular2-jwt';
import { Subscription } from "rxjs";
//local
import { CheckoutService } from "./checkout.service";
// //Payment
import { PaymentService, ProductSubType } from "@acepteam/payment";
import { PaymentComponent } from "@acepteam/payment";
import {
	PaymentSummary,
	PaymentUIConfiguration,
	OrderDetails,
	CustType,
	GPOrgCode,
	OrderSource,
	OrderTypeCode,
	OrgCode,
	CardType,
	PaymentType
} from "@acepteam/payment";
//global
import * as acepglobal from "@acepteam/globalspack";
import { DataService, LoggerService } from "../../../core/services";
import { GroupPortalDataService, EmailHelperService } from "../../services";
import { NotifyInfo } from "../../../shared/models";
import { NotificationStatus } from "../../../shared/enums/data.enums";
import { $ } from "../../../../../node_modules/protractor";

@Component({
	selector: "app-checkout",
	templateUrl: "./checkout.component.html",
	styleUrls: ["./checkout.component.scss"],
	encapsulation: ViewEncapsulation.None
	//   styleUrls: ['./checkout.component.scss', './resources/css/shoppingcart.css', './resources/css/temp.css', './resources/css/dd.css',
	// '../../../../../../../../globalassets/css/vandelay.css'
	// ]
})
export class CheckoutComponent implements OnInit, AfterViewInit {
	totalamount: any;
	orderNumber: string = "";
	maskedccnum: string = "";
	pingResponseFromClientRxd: boolean = false;
	subscriptions: Array<Subscription> = [];
	usercontext: any = null;
	termsAndConditionsText: string = "";

	paymentsummary: PaymentSummary = new PaymentSummary();
	paymentuiconfig: PaymentUIConfiguration = new PaymentUIConfiguration();
	orderdetails: OrderDetails;
	isClientCallbackAvailable: boolean = false;
	CardType: typeof CardType = CardType;
	PaymentType: typeof PaymentType = PaymentType;
	ProductSubType: typeof ProductSubType = ProductSubType;
	@ViewChild("payment") payment: PaymentComponent;

	constructor(
		public ssosvc: acepglobal.AcepSSOService,
		public globaldomops: acepglobal.GlobalDomOpsService,
		public globaldataops: acepglobal.GlobalDataOpsService,
		public dataService: DataService,
		public groupPortalDataService: GroupPortalDataService,
		private commonOpsService: acepglobal.CommonOperationsService,
		private checkoutService: CheckoutService,
		public paymentservice: PaymentService,
		public emailHelperService: EmailHelperService,
		public loggerService: LoggerService
	) {
		//super(ssosvc, globaldomops, globaldataops, authHttp);
		// this.orderdetails.orderLineItems[0].ProductSubType = ProductSubType.
	}

	ngOnInit() {
		this.initdata();
	}

	ngAfterViewInit() {
		//Moved to view child because payment viewchild is not available in onint
		// https://stackoverflow.com/questions/34947154/angular-2-viewchild-annotation-returns-undefined

		if (this.payment) {
			this.globaldomops.showwait();
			this.globaldomops.continueToWait = true;

			this.paymentservice.uidata.Countries = this.dataService.uidata.Countries;
			this.paymentservice.uidata.StateProvinces = this.dataService.uidata.StateProvinces;

			this.checkoutService.AddPaymentUIConfiguration();

			this.checkoutService
				.CalculateOrder(this.groupPortalDataService.memberAppData)
				.subscribe(
					(res: any) => {
						this.handleOrderGenErrors();
						this.orderdetails = this.paymentservice.orderdetails;
						this.paymentservice.MapValidationOrderDetails(res);
						this.payment.initPaymentComponentExternal(res);
						this.globaldomops.hidewait();
					},
					error => {
						this.groupPortalDataService.notify(
							NotificationStatus.Error
						);
					},
					() => { }
				);

			// this.payment.initPaymentComponent();
		}
	}

	handleOrderGenErrors() {
		if (this.paymentservice.orderdetails.orderLineItems.length == 0) {
			this.groupPortalDataService.notify(NotificationStatus.Error);
			this.loggerService.logError(
				"No Order Line Items obtained from Calculate Order Web Service call"
			);
		}
	}

	updateOrder() {
		this.orderdetails.TotalAmount = 0;
		this.orderdetails.orderLineItems.forEach(li => {
			if (li.Modifiable) {
				li.UnitPrice = li.Selected ? li.UnitPrice : 0;
			}
			//li.UnitPrice = parseFloat(li.UnitPrice).toFixed(2);
			if (li.Selected) {
				this.orderdetails.TotalAmount += +li.UnitPrice;
			}
		});
		this.payment.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS = this.orderdetails.TotalAmount;
	}

	updatePriceFormat() {
		this.orderdetails.orderLineItems.forEach(li => {
			li.UnitPrice =
				li.UnitPrice == "" ? 0.0 : parseFloat(li.UnitPrice).toFixed(2);
			this.orderdetails.TotalAmount += +li.UnitPrice;
		});
	}

	initdata() {
		//this.paymentservice.paymentWebServicePath = 'http://localhost:50003/api/orders/';

		this.orderdetails = this.groupPortalDataService.memberAppData.orderDetails = new OrderDetails();
		// this.termsAndConditionsText = this.groupPortalDataService.getContentSnippet(
		// 	`memberappLICATION_TERMSANDCONDITIONS_${this.globaldataops.GetORG()}`
		// );

	}
	//ACCEPT OUTPUT METHODS FROM PAYMENT COMPONENT //
	updatePaymentSummary(_paysummary: PaymentSummary) {
		this.paymentsummary = _paysummary;
	}

	OrderProcessingCompleted(response: any) {
		this.globaldomops.notify(
			"Congratulations. Your order has been placed successfully"
		);
		this.orderdetails = this.payment.od;
		this.orderdetails.OrderId = response;
		this.maskedccnum = this.paymentservice.MaskCreditCardNumber(
			this.orderdetails.PaymentInformation.CreditCardNumber
		);
		//the following 2 thigns are obtained by an extra call after order proceesed in ninja iinterface for place order
		this.orderNumber = this.groupPortalDataService.memberAppData.notifyInfo.orderNumber = this.paymentservice.orderNumber;
		this.orderdetails.TotalAmount = this.paymentservice.orderdetails.TotalAmount;
		this.groupPortalDataService.memberAppData.orderDetails = this.paymentservice.orderdetails;
		//this.payment.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS;

		//take the use to receipt page
		this.groupPortalDataService.notify(
			this.groupPortalDataService.memberAppData.profile.membership
				.IsOnAutoRenewal
				? NotificationStatus.RenewalSuccesful
				: NotificationStatus.NewMembershipSuccessful
		);

		//Send Manual institution emails
		this.emailHelperService.SendManualEmailContentIfAny(
			this.groupPortalDataService.memberAppData
		);
		//Run Order Recpt Workflow
		this.emailHelperService.RunOrderReceiptWorkflow(
			this.groupPortalDataService.memberAppData
		);
	}

	submitpayment(event) {
		event.stopPropagation();
		this.payment.SynchDataFromChildComponents();
		if (this.globaldomops.CheckValidations(event)) {
			//this.paymentservice.OpenPaymentPreview();

			//Update order line items--pass only the ones that are marked selected
			//this.UseOnlySelectedLineItems();

			this.payment.PlaceOrder();
		}

		return false;
	}

	// UseOnlySelectedLineItems()
	// {
	//   //Update line items in main order
	//   let odDeepCopy: OrderDetails = this.commonOpsService.DeepCopyObject(this.paymentservice.orderdetails);
	//   odDeepCopy.orderLineItems =  odDeepCopy.orderLineItems.filter(a=>a.Selected);
	//   this.payment.od.orderLineItems = this.paymentservice.orderdetails.orderLineItems = odDeepCopy.orderLineItems;
	// }

	ApplyPromoCode() {
		this.paymentservice.ApplyPromoCode().subscribe(
			(response: any) => {
				if (response.promoCodeValid) {
					this.globaldomops.notify("Promo Code Applied!!");
					this.paymentsummary = {
						TOTALDISCOUNT: response.totalDiscount,
						TOTALTAXES: response.totalTaxes,
						TOTALAMOUNTWITHTAXESANDDISCOUNTS: response.totalAmount,
						PROMOCODEMESSAGE: response.promoMsg,
						TOTALSHIPPING: response.totalShipping
					};
				} else {
					this.globaldomops.notify(
						`Invalid ${this.paymentservice.paymentuiconfig.PRMOCODELABEL
						}!!`,
						"",
						"error"
					);
				}
			},
			error => {
				this.ssosvc.CheckAuthorizationOnResponse(error);
				this.globaldomops.notify(
					"Promo Code Could not apply!!",
					"",
					"error"
				);
			},
			() => {
				this.globaldomops.hidewait();
			}
		);
	}

	printReceipt() {
		this.paymentservice.printReceipt();
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptions.forEach((subscription: Subscription) => {
			subscription.unsubscribe();
		});
	}
}
